import React, { useState } from "react";
import { ReactComponent as UpwardIcon } from "../../../../Assets/Icons/upwardBlueIcon.svg";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { separateDateTimeAndConvertToLocale } from "../../../../utils/utilFunctions";
import { ReactComponent as ValidIcon } from "../../../../Assets/Icons/validsvg.svg";
import { ReactComponent as RulesIcon } from "../../../../Assets/Icons/rules&regulationsvg.svg";

const OfferDetails = ({ offerData }) => {
  const [showAllRules, setShowAllRules] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  var settings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
  };

  // Compute consistent discount label and type tag
  const discountText = offerData?.discountTitle || (
    offerData?.discountRange !== undefined && offerData?.discountRange !== null
      ? `Discounted Offer ${offerData?.discountRange}%`
      : null
  );
  const offerTypeTag = offerData?.offerType === 'INSTORE_SWOODLE_OFFER'
    ? 'In-store'
    : (offerData?.offerType === 'ONLINE_OFFER' ? 'Online' : '');

  return (
    <div className="redeem-offer-wrapper flex justify-center items-center w-full bg-[#F8F9FB] shadow-lg" style={{ boxShadow: '0 4px 24px 0 rgba(0,0,0,0.15)' }}>
      <div style={{ background: '#F2F4F5', borderRadius: '16px', width: '95%', display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '0 auto', padding: '8px 0' }}>
        {/* Ticket-shaped image at balanced size */}
        <div className="ticket-image-multi-cutout w-[95%] h-[125px] mb-4 mx-auto mt-1" style={{ background: '#000', position: 'relative' }}>
          {offerData?.previewImages?.length > 1 ? (
            <Slider className="w-full h-full" {...settings}>
              {offerData?.previewImages?.map((url, idx) => {
                const isAbsolute = typeof url === 'string' && /^(https?:)?\/\//i.test(url);
                const resolved = isAbsolute ? url : `${process.env.REACT_APP_S3_URL || ''}${url || ''}`;
                return (
                  <img key={idx} src={resolved} className="w-full h-full object-cover" style={{ background: 'transparent', borderRadius: 0 }} />
                );
              })}
            </Slider>
          ) : (
            (() => {
              const url = offerData?.previewImages?.[0];
              const isAbsolute = typeof url === 'string' && /^(https?:)?\/\//i.test(url);
              const resolved = isAbsolute ? url : `${process.env.REACT_APP_S3_URL || ''}${url || ''}`;
              return (
                <img src={resolved} className="w-full h-full object-cover" style={{ background: 'transparent', borderRadius: 0 }} />
              );
            })()
          )}
        </div>
        {/* Dots indicator */}
        {offerData?.previewImages?.length > 1 && (
          <div className="flex justify-center items-center w-full mb-3" style={{ marginTop: '2px' }}>
            {offerData.previewImages.map((_, idx) => (
              <span
                key={idx}
                style={{
                  display: 'inline-block',
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  background: idx === currentSlide ? '#00ADEF' : '#D1EAF6',
                  margin: '0 3px',
                  transition: 'background 0.2s',
                }}
              />
            ))}
          </div>
        )}
        {/* Card Content */}
        <div className="flex flex-col items-start justify-start w-full px-6 pt-0 pb-2">
          <p className="font-poppins font-[700] text-[16px] text-[#222] mb-2">
            {offerData?.title}
          </p>
          <p className="font-poppins font-[400] text-[12px] text-[#767676] mb-3 break-words w-full" style={{ wordBreak: 'break-word' }}>
            {offerData?.description}
          </p>
          {/* Tags - show actual category/subcategories and types from offerData */}
          <div className="flex flex-wrap gap-2 mb-3">
            {offerData?.category?.title && (
              <span className="bg-[#E6F7FF] text-[#00ADEF] text-[11px] font-[500] rounded-[4px] px-2 py-1 flex items-center">
                {offerData?.category?.title}
              </span>
            )}
            {Array.isArray(offerData?.subCategory) && offerData?.subCategory.map((s, idx) => (
              <span key={idx} className="bg-[#E6F7FF] text-[#00ADEF] text-[11px] font-[500] rounded-[4px] px-2 py-1 flex items-center">
                {s?.title}
              </span>
            ))}
            {offerTypeTag && (
              <span className="bg-[#E6F7FF] text-[#00ADEF] text-[11px] font-[500] rounded-[4px] px-2 py-1 flex items-center">{offerTypeTag}</span>
            )}
            {discountText && (
              <span className="bg-[#E6F7FF] text-[#00ADEF] text-[11px] font-[500] rounded-[4px] px-2 py-1 flex items-center">{discountText}</span>
            )}
          </div>
          {/* Validity */}
          <div className="flex items-center gap-2 mb-2">
            <ValidIcon className="w-[14px] h-[14px] text-[#8C8C8C]" />
            <span className="text-[#8C8C8C] text-[12px]">Valid until {separateDateTimeAndConvertToLocale(offerData?.endDate)?.localDate || 'June 17, 2025'}</span>
          </div>
          {/* Rules & Regulations */}
          <div className="flex items-start gap-2 mb-2">
            <RulesIcon className="w-[14px] h-[14px] text-[#8C8C8C] mt-[1px]" />
            <span className="text-[#8C8C8C] text-[12px]">Rules and regulations:</span>
          </div>
          <div className={`rules-list-anim ${showAllRules ? 'expanded' : ''}`}>
            <ul className="list-disc pl-5 text-[#767676] text-[11px] mb-2">
              {offerData?.ruleAndRegulation?.length > 0 ? (
                (showAllRules
                  ? offerData?.ruleAndRegulation
                  : offerData?.ruleAndRegulation.slice(0, 3)
                ).map((rule, idx) => (
                  <li key={idx}>{rule?.title}</li>
                ))
              ) : (
                <>
                  <li>Valid only in NSW.</li>
                  <li>This offer may also be used when dining alone.</li>
                  <li>Valid for Dine-In.</li>
                </>
              )}
            </ul>
          </div>
          {/* View More */}
          {offerData?.ruleAndRegulation?.length > 3 && !showAllRules && (
            <button className="text-[#000000] text-[12px] font-[500] flex items-center gap-1 mb-3 bg-transparent border-none p-0 cursor-pointer" onClick={() => setShowAllRules(true)}>View More <span>&#8594;</span></button>
          )}
          {showAllRules && offerData?.ruleAndRegulation?.length > 3 && (
            <button className="text-[#000000] text-[12px] font-[500] flex items-center gap-1 mb-3 bg-transparent border-none p-0 cursor-pointer" onClick={() => setShowAllRules(false)}>View Less <span>&#8593;</span></button>
          )}
        </div>
        {/* Redeem Button */}
        <div className="w-full px-6" style={{ paddingBottom: '8px', marginBottom: 0, minHeight: '55px' }}>
          <button className="w-full bg-[#00ADEF] text-white font-poppins font-[600] text-[14px] rounded-[6px] py-3 mt-0 mb-0" style={{ marginBottom: 0, minHeight: '40px' }}>Redeem</button>
        </div>
      </div>
    </div>
  );
};

export default OfferDetails;
